export default function Canvas_Curves() {
  return (
    <div>
      <h1>Canvas_Curves Component</h1>
    </div>
  );
}
